import React, {useEffect} from 'react';

import {hooks} from '../../hooks';
import {components} from '../../components';
import {actions} from '../../store/actions';
import {salon} from '../../config/salon';

export const Social: React.FC = () => {
  const dispatch = hooks.useDispatch();

  hooks.useThemeColor('#FFF7F4');

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(actions.setColor('#FFF7F4'));
  }, [dispatch]);

  return (
    <>
      <components.Header
        title='Instagram'
        showLogo={true}
        showBasket={true}
        headerStyle={{backgroundColor: 'var(--main-background)'}}
      />
      <main className='scrollable salon-main salon-main--quiet'>
        <components.HeroSlider />
        <section className='salon-section'>
          <article className='salon-social-card'>
            <span className='salon-eyebrow signature-text'>
              {salon.tagline}
            </span>
            <h2>{salon.instagramHandle}</h2>
            <p>
              Salon duyuruları, işlem örnekleri ve güncel paylaşımlar için
              Instagram hesabını ziyaret edin.
            </p>
            <div className='salon-actions'>
              <a
                className='salon-button salon-button--light'
                href={salon.instagramHref}
                target='_blank'
                rel='noreferrer'
              >
                Instagram'a Git
              </a>
              <a
                className='salon-button salon-button--outline'
                href={salon.phoneHref}
              >
                Ara
              </a>
            </div>
          </article>
        </section>
        <section className='salon-section'>
          <div className='salon-info-grid'>
            <article className='salon-contact-card'>
              <h3>{salon.brand}</h3>
              <p>
                <span className='signature-text'>{salon.tagline}</span>
              </p>
            </article>
            <article className='salon-contact-card'>
              <h3>Telefon</h3>
              <p>
                <a href={salon.phoneHref}>{salon.phone}</a>
              </p>
            </article>
            <article className='salon-contact-card'>
              <h3>Adres</h3>
              <p>
                <a
                  href={salon.mapsHref}
                  target='_blank'
                  rel='noreferrer'
                >
                  {salon.address}
                </a>
              </p>
            </article>
          </div>
        </section>
      </main>
      <components.QuickContact />
      <components.Footer />
    </>
  );
};
